import { render, staticRenderFns } from "./hs-checkbox.vue?vue&type=template&id=1c58d0b0&scoped=true&"
import script from "./hs-checkbox.vue?vue&type=script&lang=js&"
export * from "./hs-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./hs-checkbox.vue?vue&type=style&index=0&id=1c58d0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c58d0b0",
  null
  
)

export default component.exports